import { useEffect, useMemo, useState } from 'react';
import { listenContacts, listenMasters } from '../firebase/repo';
import { DEFAULT_DROPDOWNS, DROPDOWN_GROUP_OPTIONS, normalizeDropdownValue } from '../types/dropdowns';
import type { Contact, MasterItem, MasterType } from '../types';

export function useMasters(uid?: string) {
  const [masters, setMasters] = useState<MasterItem[]>([]);
  const [contacts, setContacts] = useState<Contact[]>([]);

  useEffect(() => {
    if (!uid) return;
    const offMasters = listenMasters(uid, setMasters);
    const offContacts = listenContacts(uid, setContacts);
    return () => { offMasters(); offContacts(); };
  }, [uid]);

  const grouped = useMemo(() => {
    const map = Object.fromEntries(DROPDOWN_GROUP_OPTIONS.map((group) => [group, []])) as unknown as Record<MasterType, string[]>;
    masters.filter((m) => m.active).forEach((m) => {
      const group = m.group || m.type;
      if (!group || !map[group] || !m.value) return;
      const exists = map[group].some((value) => normalizeDropdownValue(value) === normalizeDropdownValue(m.value));
      if (!exists) map[group].push(m.value);
    });
    DROPDOWN_GROUP_OPTIONS.forEach((group) => {
      if (!map[group].length) map[group] = DEFAULT_DROPDOWNS[group];
    });
    return map;
  }, [masters]);

  return { masters, contacts, grouped };
}
